var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "setting-container"
  }, [_c("a-card", {
    attrs: {
      hoverable: true,
      bordered: false
    }
  }, [_c("a-card", {
    attrs: {
      title: "基本资料",
      bordered: false
    }
  }, [_c("account-base")], 1), _c("a-card", {
    attrs: {
      title: "安全设置",
      bordered: false
    }
  }, [_c("security-setting")], 1), _c("a-card", {
    attrs: {
      title: "个性化",
      bordered: false
    }
  }, [_c("custom-setting")], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };